import { useSearchParams, Link } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

const PaymentCancel = () => {
  const [searchParams] = useSearchParams();
  const jobId = searchParams.get('job_id');

  return (
    <div className="min-h-screen bg-zinc-50 flex items-center justify-center p-6">
      <div className="bg-white rounded-2xl border border-zinc-200 p-8 max-w-md w-full text-center">
        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-8 h-8 text-red-600" />
        </div>
        <h1 className="text-2xl font-bold text-zinc-900 mb-2" style={{ fontFamily: 'Manrope, sans-serif' }}>
          Payment Cancelled
        </h1>
        <p className="text-zinc-600 mb-6">
          Your payment was cancelled. Don't worry - your job request is still saved and you can pay later.
        </p>
        <Link to="/dashboard">
          <Button className="bg-orange-500 hover:bg-orange-600 text-white rounded-full px-8" data-testid="back-to-dashboard-btn">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Dashboard
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default PaymentCancel;
